import { useReducer } from 'react';
import { AxiosResponse } from 'axios';

// api

import { api, replaceParamsInStr } from '../../common-utils-services/axiosUtil';
import endpoints from '../../../constants/configs/endpoints';

const actions = {
    GET_INS_COMPANY: 'GET_INS_COMPANY',
    GET_WEB_BROKER: 'GET_WEB_BROKER',
    SEARCH_CARRIER_BY_ZIP: 'SEARCH_CARRIER_BY_ZIP'
};


// /hix/partner/list?isCarrierFlag=Y&zipCode=31721&countyCode=13007
// N for web-broker

// endpoints

const CARRIER_FOR_DEV_ENV = '/mocks/carriers/carrier.json';
const CARRIER_SEARCH_FOR_DEV_ENV = '/mocks/carriers/search-carrier.json';
const CARRIER_SEARCH_ZIP_COUNTY_CODE_FOR_DEV_ENV = '/mocks/carriers/search-results-zip-county-code.json';
const VALIDATE_ZIP_MULTIPLE_RESULTS_FOR_DEV_ENV = '/mocks/carriers/validate-zip-multiple-results.json';
const VALIDATE_ZIP_SINGLE_RESULTS_FOR_DEV_ENV = '/mocks/carriers/validate-zip-single-result.json';
const VALIDATE_ZIP_NO_RESULTS_FOR_DEV_ENV = '/mocks/carriers/validate-zip-no-results.json';
const CARRIER_SEARCH_NO_RESULTS_FOR_DEV_ENV = '/mocks/carriers/no-results.json';
const WEBBROKER_FOR_DEV_ENV = '/mocks/carriers/web-broker.json';
export type EDE_LEVEL = 1 | 2 | 3;


interface ValidateZipDetail {
    countyCode: string;
    globalStateCode: string;
    stateCode: string;

}
type ValidateZipResults = {
  [key: string]: ValidateZipDetail;
};
type County = {
    [key: string]: string;
};

export interface CountyZip {
    value: string;
    label: string;
}

export interface Partner {
    partnerId: number;
    organizationName: string;
    landingPageUrl: string | null;
    contactNumber: string | null;
    logoUrl: string;
    edeLevel?: EDE_LEVEL;
    ttyNumber: string;
    sadpIndicator: boolean;
    carrierFlag: boolean;
  }

  export interface CarrierApiResponseProps {
    statusCode: number;
    status: string;
    message: string | null;
    total: number;
    payload: {
        zipcode: string;
        counties: County;
        partners: Partner[];
    }
};

export interface SearchResultProps {
    data: CarrierApiResponseProps | AxiosResponse | null,
    counties: CountyZip[]
};

type Action =
  | { type: 'GET_INS_COMPANY', payload: SearchResultProps | null }
  | { type: 'GET_WEB_BROKER', payload: SearchResultProps | null }
  | { type: 'SEARCH_CARRIER_BY_ZIP', payload: SearchResultProps | null }

function reducer(state, action: Action) {
    switch (action.type) {
        case actions.GET_INS_COMPANY:
            return {
                ...state,
                data: action.payload
            };
        case actions.GET_WEB_BROKER:
            return {
                ...state,
                data: action.payload
            };
        case actions.SEARCH_CARRIER_BY_ZIP:
            return {
                ...state,
                data: action.payload,
            };
        default:
            return state;
    }
}

const initialState: CarrierApiResponseProps | undefined = undefined;

export default () => {
    const [data, dispatch]  = useReducer(reducer, initialState);

    // prepend http or https
    const formatUrl = (urlToFormat: string) => {
        let removeQuestionMark = urlToFormat.startsWith('?') ? urlToFormat.substring(1): urlToFormat;
        const urlPattern = new RegExp(
          /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
        );
        if (urlPattern.test(removeQuestionMark)) {
          //string is url

          ///clear http && https from string
          let newUrl = removeQuestionMark.replace("https://", "").replace("http://", "");

          //add https to string
          newUrl = `https://${newUrl}`;
          return newUrl;
        }
        return removeQuestionMark;
    };

    // format phone to this format (888) 123-4567
    const formatPhoneNumber = (phoneNumToFormat: string) => {
        var cleaned = ('' + phoneNumToFormat).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            const newPhoneNum = `(${match[1]}) ${match[2]}-${match[3]}`;
            return newPhoneNum;
        }
        return phoneNumToFormat;
    }

    const getAllInsCompanies = async () => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.PARTNER_LIST : CARRIER_SEARCH_FOR_DEV_ENV;
            const endpoint = replaceParamsInStr(url, {
                isCarrierFlag: 'Y',
                zipCode: '',
                countyCode: ''
            });
            const res = await api.get<CarrierApiResponseProps>(endpoint);
            if (res?.data?.statusCode === 200 && res?.data?.payload.partners) {
                const updatedPartners: Partner[] = res.data.payload.partners.map(item => {
                    return {
                        ...item,
                        landingPageUrl: item.landingPageUrl ? formatUrl(item.landingPageUrl) : '',
                        contactNumber: item.contactNumber ? formatPhoneNumber(item.contactNumber) : ''
                    }
                });
                dispatch({ type: 'GET_INS_COMPANY', payload: {
                    data: {
                        ...res.data,
                        payload: {
                            zipcode: res.data.payload.zipcode,
                            counties: res.data.payload.counties,
                            partners: updatedPartners
                        }
                    },
                    counties: []
                }});
            } else {
                dispatch({ type: 'GET_INS_COMPANY', payload: { data: null, counties: [] }});
            }
        } catch (e) {
            console.log(`In useGaep: getAllInsCompanies(): Request to (${endpoints.PARTNER_LIST}) failed with error = `, e);
            dispatch({ type: 'GET_INS_COMPANY', payload: { data: null, counties: [] }});
        }
    };

    const getWebBroker = async () => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.PARTNER_LIST : WEBBROKER_FOR_DEV_ENV;
            const endpoint = replaceParamsInStr(url, {
                isCarrierFlag: 'N',
                zipCode: '',
                countyCode: ''
            });
            const res = await api.get<CarrierApiResponseProps>(endpoint);
            if (res?.data?.statusCode === 200 && res?.data?.payload.partners) {
                const updatedPartners: Partner[] = res.data.payload.partners.map(item => {
                  return {
                      ...item,
                      landingPageUrl: item.landingPageUrl ? formatUrl(item.landingPageUrl) : '',
                      contactNumber: item.contactNumber ? formatPhoneNumber(item.contactNumber) : ''
                  }
                });
                dispatch({ type: 'GET_WEB_BROKER', payload: {
                    data: {
                        ...res.data,
                        payload: {
                            zipcode: res.data.payload.zipcode,
                            counties: res.data.payload.counties,
                            partners: updatedPartners
                        }
                    },
                    counties: []
                }});
            } else {
                dispatch({ type: 'GET_WEB_BROKER', payload: { data: null, counties: [] }});
            }
        } catch (e) {
            console.log(`In useGaep: getWebBroker(): Request to (${endpoints.PARTNER_LIST}) failed with error = `, e);
            dispatch({ type: 'GET_WEB_BROKER', payload: { data: null, counties: [] }});
        }
    };

    const searchCarriersByZipcode = async (zipCode: string, countyCode?: string) => {
        const url = global.__ENV__.PRODUCTION ? endpoints.PARTNER_LIST : CARRIER_SEARCH_FOR_DEV_ENV;
        let endpoint = replaceParamsInStr(url, {
            isCarrierFlag: 'Y',
            zipCode
        });
        if (global.__ENV__.PRODUCTION && countyCode) {
            endpoint += `&countyCode=${countyCode}`;
        }

        const res = await api.get<CarrierApiResponseProps>(endpoint);
        let counties: CountyZip[] = [];
        if (res?.data?.payload?.counties && Object.entries(res.data.payload.counties).length > 0) {
            Object.entries(res.data.payload.counties).forEach(([key, value]) => {
                counties.push({ label: key, value: value as string });
            });
        }

        // remove dups
        // counties = counties.filter((tag, index, array) => array.findIndex(t => t.label === tag.label && t.value === tag.value) == index);

        let updatedPartners: Partner[] = [];
        if (res?.data?.payload?.partners) {
            updatedPartners = res.data.payload.partners.map(item => {
                return {
                    ...item,
                    landingPageUrl: item.landingPageUrl ? formatUrl(item.landingPageUrl) : '',
                    contactNumber: item.contactNumber ? formatPhoneNumber(item.contactNumber) : ''
                }
            });
        }
        return Promise.resolve({
            data: {
                ...res.data,
                payload: {
                    counties: res?.data?.payload?.counties || {},
                    partners: updatedPartners
                }
            },
            counties
        });
    };

    const validateZip = async(zipCode: string) => {
        const url = global.__ENV__.PRODUCTION ? endpoints.VALIDATE_ZIP : VALIDATE_ZIP_MULTIPLE_RESULTS_FOR_DEV_ENV;

        let formData = new FormData();
        formData.append("zip", zipCode);
        const res = global.__ENV__.PRODUCTION ? await api.post<ValidateZipResults>(url, formData): await api.get<ValidateZipResults>(url);

        let counties: CountyZip[] = [];
        if (res?.data && Object.entries(res.data).length > 0) {
            Object.entries(res.data).forEach(([key, value]) => {
                counties.push({ label: key, value: value.countyCode as string });
            });
        }

        return Promise.resolve({
            counties
        });
    }

    return {
      ...data,
        getAllInsCompanies: () => {
            getAllInsCompanies();
        },
        getWebBroker: () => {
            getWebBroker();
        },
        searchCarriersByZipcode: (zipCode: string, countyCode?: string) => {
            return searchCarriersByZipcode(zipCode, countyCode);
        },
        validateZip: (zipCode: string) => {
            return validateZip(zipCode);
        }
    };
};